import {Component, OnInit} from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-two-door-d',
  templateUrl: './two-door-d.component.html',
  styleUrls: ['./two-door-d.component.scss']
})
export class TwoDoorComponentD implements OnInit {

  constructor(public coef: CoefService) {
  }

  ngOnInit() {
  }

}
